import Joi from 'joi';
import blockAppearanceSchema from '@utils/validate/blocksSchemes/blockAppearanceSchema';
const tableSchema = Joi.object({
  type: Joi.string().valid('table').required(),
  code: Joi.string().allow('', null).required(),
  table: Joi.array().items(Joi.array().items(Joi.string().allow('', null))),
  ...blockAppearanceSchema
}).unknown(true);
export default tableSchema;